import {Link, useNavigate} from 'react-router-dom';
import {SoopSectionTitle} from '@soop-ui/soop-ui';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {sendHelpClickLog} from '@/utils/help/log';
import {useAutoCloseDialog} from '@/hooks/help';
import CallInfoLayer from '../CallInfoLayer';
import ReportSelectLayer from '../ReportSelectLayer';
import styles from './InquiryBanner.module.scss';

const InquiryBanner = () => {
  const {isMobile} = useHelpContext();
  const navigate = useNavigate();
  const {openDialog} = useAutoCloseDialog();

  const sendClickLog = (
    buttonType: (typeof HELP_LOG.BUTTON_TYPE)[keyof typeof HELP_LOG.BUTTON_TYPE],
    actionType?: (typeof HELP_LOG.ACTION_TYPE)[keyof typeof HELP_LOG.ACTION_TYPE],
  ) => {
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_BANNER, {
      buttonType,
      ...(actionType ? {actionType} : {}),
    });
  };

  const handleOpenInquiry = () => {
    sendClickLog(HELP_LOG.BUTTON_TYPE.CS_INQUIRY);
  };

  const handleOpenCall = () => {
    openDialog({
      component: () => <CallInfoLayer isMobile={isMobile} />,
      scrollLock: true,
    });
    sendClickLog(HELP_LOG.BUTTON_TYPE.CS_CALL);
  };

  const handleOpenReport = () => {
    if (isMobile) {
      navigate(ROUTE.HELP.REPORT);
    } else {
      openDialog({component: () => <ReportSelectLayer />, scrollLock: true});
    }
    sendClickLog(HELP_LOG.BUTTON_TYPE.CS_REPORT, HELP_LOG.ACTION_TYPE.GATE);
  };

  const handleOpenMyInquiry = () => {
    sendClickLog(HELP_LOG.BUTTON_TYPE.CS_MY_HISTORY, HELP_LOG.ACTION_TYPE.LIST);
  };

  return (
    <div className={styles.InquiryBannerWrapper}>
      <SoopSectionTitle>
        <SoopSectionTitle.Title size='lg'>
          다른 도움이 필요하신가요?
        </SoopSectionTitle.Title>
      </SoopSectionTitle>
      <div className={styles.InquiryBannerList}>
        <ul>
          <li>
            <Link to={ROUTE.HELP.INQUIRY} onClick={handleOpenInquiry}>
              <em className={styles.IcoFAQ}></em> 문의하기
            </Link>
          </li>
          <li>
            <button type='button' onClick={handleOpenReport}>
              <em className={styles.IcoDeclare}></em>신고하기
            </button>
          </li>
          <li>
            <button type='button' onClick={handleOpenCall}>
              <em className={styles.IcoCall}></em>전화상담
            </button>
          </li>
          <li>
            <Link to={ROUTE.HELP.MY_INQUIRY} onClick={handleOpenMyInquiry}>
              <em className={styles.IcoIllegal_filming}></em> 나의 문의 내역
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InquiryBanner;
